var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRefreshBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4844 7.00022H14.75C15.1656 7.00022 15.5 6.66585 15.5 6.25022V2.25022C15.5 1.9471 15.3187 1.6721 15.0375 1.55647C14.7562 1.44085 14.4344 1.50335 14.2187 1.71897L12.9187 3.01897C10.1812 0.315849 5.77186 0.325224 3.04999 3.05022C0.315613 5.7846 0.315613 10.2158 3.04999 12.9502C5.78436 15.6846 10.2156 15.6846 12.95 12.9502C13.3406 12.5596 13.3406 11.9252 12.95 11.5346C12.5594 11.144 11.925 11.144 11.5344 11.5346C9.58124 13.4877 6.41561 13.4877 4.46249 11.5346C2.50936 9.58147 2.50936 6.41585 4.46249 4.46272C6.40624 2.51897 9.54686 2.5096 11.5031 4.43147L10.2187 5.71897C10.0031 5.9346 9.94061 6.25647 10.0562 6.53772C10.1719 6.81897 10.4469 7.00022 10.75 7.00022H14.4844Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefreshBlue);
export default __webpack_public_path__ + "static/media/ic_refresh_blue.ae6fd9c65c7f0057c2dd8ec00f97df1f.svg";
export { ForwardRef as ReactComponent };